import ProfileWarningIcon from 'assets/ver2/icons/warning-white-icon.svg';
import CalculatorModal from 'components/fx/CalculatorModal';
import {
  NAVBAR_FOOTER_ACTIONS,
  ORDER_EMAIL,
  PROFILE_PREFIX,
  RECEIVERS_ADD_SUFIX,
  TABLET_MIN_WIDTH,
  TRANSACTION_ADD_PREFIX,
} from 'constants';
import { NAV_MENUS_MOBILE_AUTHENTICATED } from 'constants/header/ver3';
import useProfile from 'features/profile2.0/hooks/useProfile';
import Cookies from 'helpers/cookies';
import { MAKE_PAYMENT_KEY } from 'hooks/form-add-transaction/useAddTransaction';
import { FX_MAKE_PAYMENT_KEY } from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useFormAddTransactionStore from 'hooks/form-add-transaction/useFormAddTransactionStore';
import useCommonStore from 'hooks/useCommonStore';
import useLang from 'hooks/useLang';
import usePage from 'hooks/usePage';
import { isEmpty } from 'lodash';
import { Fragment, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import BackdropCommon from '../../BackdropCommon';
import AddIcon from '../../Icons/AddIcon';
import ArrowDownIcon from '../../Icons/ArrowDownIcon';

const NavbarFooter = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { notifications } = useCommonStore();

  const [isOpenActions, setOpenActions] = useState(false);
  const [isShowCalculatorModal, setShowCalculatorModal] = useState(false);

  const { resetAddTransactionInformation } = useFxFormAddTransactionStore();
  const { resetSendMoneyFlow } = useFormAddTransactionStore();
  const { isMaintenancePage } = usePage();
  const { isProfileStatusPendingPII } = useProfile();

  const notificationsUnRead = !isEmpty(notifications)
    ? notifications?.filter(({ read }) => !read)
    : [];

  const isNavLinkActive = (href, href2, href3, href4) => {
    return (
      pathname.includes(href) ||
      pathname.includes(href2) ||
      pathname.includes(href3) ||
      pathname.includes(href4)
    );
  };

  const handleActionButtonOnClick = () => {
    setOpenActions(!isOpenActions);
  };

  const handleOnShowCalculatorModal = () => {
    Cookies.remove(FX_MAKE_PAYMENT_KEY);
    Cookies.remove(ORDER_EMAIL);
    resetAddTransactionInformation();
    setShowCalculatorModal(true);
  };
  const handleOnCloseCalculatorModal = () => {
    setShowCalculatorModal(false);
  };
  const handleActionItemOnClick = (action) => {
    if (action === NAVBAR_FOOTER_ACTIONS[0].name) {
      Cookies.remove(MAKE_PAYMENT_KEY);
      resetSendMoneyFlow();
      navigate(`${TRANSACTION_ADD_PREFIX}`);
    }

    if (action === NAVBAR_FOOTER_ACTIONS[1].name) {
      handleOnShowCalculatorModal();
    }

    if (action === NAVBAR_FOOTER_ACTIONS[2].name) {
      navigate(`${RECEIVERS_ADD_SUFIX}`);
    }
  };

  const renderProfileWarningIcon = (nav, index) => {
    const { href } = nav || {};
    if (href !== PROFILE_PREFIX) return null;
    if (isProfileStatusPendingPII)
      return <NavWarningIcon src={ProfileWarningIcon} />;
    if (!!notificationsUnRead?.length) return <DotIcon />;
    return null;
  };

  if (isMaintenancePage) return null;
  return (
    <>
      {isShowCalculatorModal && (
        <CalculatorModal
          isOpen={isShowCalculatorModal}
          onClose={handleOnCloseCalculatorModal}
        />
      )}

      <NavbarStyled>
        <NavStyled className="me-auto">
          {NAV_MENUS_MOBILE_AUTHENTICATED.slice(0, 2).map((nav, index) => (
            <Fragment key={nav.href || index}>
              {nav.href ? (
                <NavLink
                  to={nav.href}
                  $isActive={isNavLinkActive(
                    nav.href,
                    nav.href2,
                    nav.href3,
                    nav.href4
                  )}
                  $color={'var(--ds-c-blue-hyperlink-default)'}
                >
                  {nav.icon && (
                    <NavIcon
                      key={nav.href}
                      src={nav.icon}
                      width={24}
                      height={24}
                      $isActive={isNavLinkActive(
                        nav.href,
                        nav.href2,
                        nav.href3,
                        nav.href4
                      )}
                    />
                  )}
                  {t(nav.text)}
                </NavLink>
              ) : (
                <NavLink />
              )}
            </Fragment>
          ))}
          <NavLink $isActive={true}>
            <AddIcon
              size={{ width: 44, height: 44 }}
              color="var(--ds-c-grey-dark)"
              strokeWidth="5"
              styles={{
                backgroundColor: 'var(--bg-primary)',
                borderRadius: '50%',
                boxShadow: '0px -2px 2px rgba(0, 0, 0, 0.05)',
              }}
              onClick={handleActionButtonOnClick}
            />
          </NavLink>
          {NAV_MENUS_MOBILE_AUTHENTICATED.slice(2).map((nav, index) => (
            <Fragment key={nav.href || index}>
              {nav.href ? (
                <NavLink
                  to={nav.href}
                  $isActive={isNavLinkActive(
                    nav.href,
                    nav.href2,
                    nav.href3,
                    nav.href4
                  )}
                  $color={'var(--ds-c-blue-hyperlink-default)'}
                >
                  <NavIcon
                    key={nav.href}
                    src={nav.icon}
                    width={24}
                    height={24}
                    $isActive={isNavLinkActive(
                      nav.href,
                      nav.href2,
                      nav.href3,
                      nav.href4
                    )}
                  />
                  {t(nav.text)}
                  {renderProfileWarningIcon(nav, index)}
                </NavLink>
              ) : (
                <NavLink />
              )}
            </Fragment>
          ))}
          {isOpenActions && (
            <BackdropCommon
              styles={{
                background: '#21212140',
              }}
              onClose={() => setOpenActions(false)}
            >
              <ActionWrap>
                {NAVBAR_FOOTER_ACTIONS.map((action, index) => (
                  <ActionItem
                    key={action.icon || index}
                    onClick={() => handleActionItemOnClick(action.name)}
                  >
                    <img src={action.icon} width={24} height={24} alt="" />
                    {t(action.text)}
                    <ArrowDownIcon
                      color="var(--ds-c-grey-dark)"
                      size={{ width: 14, height: 10 }}
                      styles={{
                        transform: 'rotate(270deg)',
                        position: 'absolute',
                        right: '24px',
                      }}
                    />
                  </ActionItem>
                ))}
              </ActionWrap>
            </BackdropCommon>
          )}
        </NavStyled>
      </NavbarStyled>
    </>
  );
};

const NavbarStyled = styled(Navbar)`
  position: fixed;
  bottom: 0px;
  left: 24px;
  padding: 0;
  background-color: var(--ds-c-white);
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-inline: -24px;
  box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 12px 12px 0px 0px;
`;

const NavStyled = styled(Nav)`
  height: 60px;
  margin: 0 !important;
  width: 100%;
  justify-content: space-between;

  @media screen and (min-width: ${TABLET_MIN_WIDTH}px) {
    width: unset;
    justify-content: unset;
  }
`;
const NavLink = styled(Link)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: ${(props) => (props.$isActive ? 400 : 400)};
  font-size: 10px;
  line-height: 12px;
  text-transform: capitalize;
  color: ${(props) => (props.$isActive ? props.$color : '#0E1012')};
  text-align: center;
  text-decoration: none;

  display: grid;
  align-items: center;
  justify-content: center;
  justify-items: center;
  padding: 8px 0px;
  width: 75px;
  height: 100%;
  transition: 0.3s ease;
  position: relative;

  svg {
    margin-inline: auto;

    opacity: ${(props) => (props.$isActive ? 'unset' : 0.5)};
  }

  &:hover {
    color: unset !important;
  }
`;

const ActionWrap = styled.div`
  position: absolute;
  z-index: 40;
  bottom: 0px;
  left: 0px;
  width: 100%;
`;
const ActionItem = styled.div`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: var(--ds-c-black);
  text-align: start;
  text-transform: uppercase;

  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 104px;
  background: #ffffff;
  padding-inline: 24px;

  &:first-child {
    // border-bottom: 1px solid #eef2f5;
  }

  & img {
    margin-right: 8px;
  }
`;

const NavIcon = styled.img`
  margin-right: 0px;
  filter: ${(props) =>
    props.$isActive
      ? 'invert(10%) sepia(100%) saturate(7353%) hue-rotate(236deg) brightness(92%) contrast(108%)'
      : 'invert(53%) sepia(3%) saturate(964%) hue-rotate(172deg) brightness(94%) contrast(83%)'};
`;

const DotIcon = styled.div`
  position: absolute;
  right: 26px;
  bottom: 26px;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: red;
`;
const NavWarningIcon = styled.img`
  width: 12px;
  height: 12px;
  position: absolute;
  right: 26px;
  bottom: 26px;
`;

export default NavbarFooter;
